import Vue from 'vue'
import Router from '../../../router/index.js'
import swal from 'sweetalert'
window.swal = swal
Vue.use(Router)
// import {router} from '../../../router/index.js'
const state = {
  isAuth: null,
  profilLoaded: false,
  profil: {services: []},
  successRegister: '',
  token: '',
  statusCompte: '',
  permissions: ['view-contact', 'add-team', 'edit-enterprises', 'appel-offre'],
  teamUsers: [],
  userAbonnement: [],
  approuverInvitation: {},
  actives: 0,
  listeaos: [],
  listeaosPagination: {
    total: 0,
    per_page: 10,
    current_page: 1,
    last_page: 1,
    next_page_url: '',
    prev_page_url: '',
    from: 0,
    to: 0
  },
  homeMenu: false,
  loginRedirectIntent: null
}
const mutations = {
  IS_AUTH: (state, value) => {
    state.isAuth = value
  },
  ACTIVES: (state, value) => {
    state.actives = value
  },
  GET_PROFIL: (state, profil) => {
    state.profil = profil
    state.profilLoaded = true
  },
  REDIRECT_EMAIL: (state) => {
    state.successRegister = true
  },
  GET_TOKEN: (state) => {
    state.token = Vue.auth.getToken()
  },
  STATUS_COMPTE: (state, value) => {
    state.statusCompte = Vue.auth.getStatusCompte()
  },
  TEAM_USERS: (state, value) => {
    state.teamUsers = value
  },
  APPROUVER_INVITATION: (state, value) => {
    state.approuverInvitation = value
  },
  SET_USERS: (state, value) => {
    state.teamUsers = value
  },
  SET_LIST_APPEL_OFFRE: (state, data) => {
    state.listeaos = data.data
    state.listeaosPagination = {
      total: data.total,
      per_page: data.per_page,
      current_page: data.current_page,
      last_page: data.last_page,
      next_page_url: data.next_page_url,
      prev_page_url: data.prev_page_url,
      from: data.from,
      to: data.to
    }
  },
  SET_HOME_MENU: (state, data) => {
    state.homeMenu = data
  },
  SET_APPEL_OFFRE_PAGE: (state, data) => {
    state.listeaosPagination.current_page = data
  },
  SET_LOGIN_REDIRECT_INTENT: (state, data) => {
    state.loginRedirectIntent = data
  }
}
const actions = {
  isAuthenticated (store) {
    store.commit('IS_AUTH', Vue.auth.isAuthenticated())
  },
  getActives (store, data) {
    store.commit('ACTIVES', data)
  },
  getProfilInfo (store) {
    // recupere les informations du profil
    // console.log(Router)
    // store.commit('GET_PROFIL', profil)
    let profil = {}
    if (state.isAuth) {
      window.axios.get('/u/user')
        .then(response => {
          profil = response.data
          profil.oldEmail = profil.email
          profil.oldTelephone = profil.telephone
          store.commit('GET_PROFIL', profil)
        })
        .catch(e => {
          // Router.push('/404')
        })
    }
  },
  // editer les inforamtions du profil
  setProfilInfo (store, profil) {
    store.commit('GET_PROFIL', profil)
  },
  initProfilUser (store) {
    store.commit('GET_PROFIL', {})
  },
  getteamUsers (store, team) {
    store.commit('TEAM_USERS', team)
  },
  getApprouverInvitation (store, invitation) {
    store.commit('APPROUVER_INVITATION', invitation)
  },
  setteamUsers (store, team) {
    store.commit('SET_USERS', team)
  },
  registerUser (store) {
    // swal('Bravo!', 'inscription success!', 'success')
  },
  notifStore (store, data) {
    // swal('Bravo!', 'inscription success!', 'success')
    // let notif = new window.PNotify(data)
    // return notif
  },
  setListAppelOffre (store, data) {
    // swal('Bravo!', 'inscription success!', 'success')
    store.commit('SET_LIST_APPEL_OFFRE', data)
  },
  setAppelOffrePage (store, data) {
    store.commit('SET_APPEL_OFFRE_PAGE', data)
  },
  sethomeMenu (store, data) {
    // swal('Bravo!', 'inscription success!', 'success')
    store.commit('SET_HOME_MENU', data)
  },
  setLoginRedirectIntent (store, data) {
    store.commit('SET_LOGIN_REDIRECT_INTENT', data)
  }
}
const getters = {
  isAuth: state => state.isAuth,
  profil: state => state.profil,
  successRegister: state => state.successRegister,
  token: state => state.token,
  statusCompte: state => state.statusCompte,
  permissions: state => state.permissions,
  teamUsers: state => state.teamUsers,
  approuverInvitation: state => state.approuverInvitation,
  userAbonnement: state => state.userAbonnement,
  actives: state => state.actives,
  listeaos: state => state.listeaos,
  listeaosPagination: state => state.listeaosPagination,
  homeMenu: state => state.homeMenu,
  loginRedirectIntent: state => state.loginRedirectIntent,
  profilLoaded: state => state.profilLoaded
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/store/modules/user.js